import React, {useState} from "react";
import {Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {
    getKey,
    createKey,
    deleteKey,
    listOrganizations,
    createTenantGroup,
    deleteTenantGroup,
    editTenantGroup,
    deleteRemovedEntraUsers,
    listRemovedEntraUsers,
    checkRemovedEntraUsers
} from "../municipality.actions";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import { ButtonSecondary } from "../../../components/newComponents/ButtonSecondary";
import { ButtonPrimary } from "../../../components/newComponents/ButtonPrimary";
import {CompPartitionHeader} from "../../../components/PartitionHeader";
import {CompTextField} from "../../../components/TextField";
import {CompDropdown} from "../../../components/Dropdown";
import {CompListTree} from "../../../components/ListTree";
import {ButtonSpacer} from "../../../components/ButtonSpacer";
import {CompTextFieldNew} from "../../../components/newComponents/TextField";
import moment from "moment";

const EntraIdWindow = (props) => {
    const {t} = useTranslation('translation');

    const emptyItem = {
        tenantId: props.tenantInfo.tenant.id,
        groupIdentifier: null,
        id: null,
        organizationId: null,
        role: 'ROLE_EMPLOYEE_MUNICIPALITY'
    }

    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [addOrEditOpen, setAddOrEditOpen] = useState(false);
    const [entraDeletionModalOpen, setEntraDeletionModalOpen] = useState(false);
    const [isCreate, setIsCreate] = useState(true);
    const [selectedItem, setSelectedItem] = useState({...emptyItem});
    const [rowSelect, setRowSelect] = useState(null);

    const handleRowSelect = (item, index) => {
        setRowSelect({...item});
        setSelectedRowIndex(index);
    }

    const closeAddOrEditOpen = () => {
        setAddOrEditOpen(false);
        setSelectedItem({...emptyItem});
        setRowSelect(null);
        setSelectedRowIndex(null);
    }
    const openAddOrEditOpen = (create = true) => {
        setAddOrEditOpen(true);
        setIsCreate(create);
        if (!create) {
            setSelectedItem({...rowSelect})
        }
    }

    const deleteGroup = () => {
        props.deleteTenantGroup(rowSelect.id)
    }

    const submit = () => {
        if (isCreate) {
            props.createTenantGroup(selectedItem)
        }
        else {
            props.editTenantGroup(selectedItem)
        }
        closeAddOrEditOpen()
    }



    const roles = [];
    props.userRoles.forEach((role) => {
        if (role === "ROLE_ADMIN_SYSTEM") return;
        roles.push({
            id: role,
            value: t("common." + role)
        })
    })

    const handleChange = (e) => {
        if (e.target) {
            setSelectedItem({
                ...selectedItem,
                [e.target.name]: e.target.value
            });
        }
    }

    const selectOrganization = (row, isAddAction) => {
        let value = null;
        if (isAddAction) {
            value = row.id;
        }
        setSelectedItem({
            ...selectedItem,
            organizationId: value
        });
    }

    const [selectedObjectIds, setSelectedObjectIds] = useState([]);

    const handleToggle = (objectId) => {
        setSelectedObjectIds((prev) =>
            prev.includes(objectId) ? prev.filter((id) => id !== objectId) : [...prev, objectId]
        );
    };

    return (
        <>
            <Grid size={12}>
                <TableContainer component={Paper} className={'CompSystemLogTable-container'}>
                    <Table sx={{ tableLayout: "fixed", width: "100%" }} aria-label="template table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" sx={{ width: '25%' }} className="table-header">{t('municipality.tenant_group_id')}</TableCell>
                                <TableCell align="left" sx={{ width: '25%' }} className="table-header">{t('user.user_role')}</TableCell>
                                <TableCell align="left" sx={{ width: '25%' }} className="table-header">{t('common.organization')}</TableCell>
                                <TableCell align="left" sx={{ width: '25%' }} className="table-header">{t('municipality.tenant_group_description')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.tenantInfo && props.tenantInfo.tenantGroupEntityList && props.tenantInfo.tenantGroupEntityList.map((item, index) => (
                                <TableRow
                                    key={index}
                                    tabIndex={0}
                                    role="row"
                                    hover
                                    selected={selectedRowIndex === index + 1}
                                    aria-selected={selectedRowIndex === index + 1}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleRowSelect(item, index + 1);
                                        }
                                    }}
                                    onClick={() => handleRowSelect(item, index + 1)}
                                    sx={{
                                        cursor: "pointer", width: '100%',
                                        "&:focus": { backgroundColor: "#E9EBFF" }
                                    }}
                                >
                                    <TableCell align="left" sx={{ width: '25%' }}>{item.groupIdentifier}</TableCell>
                                    <TableCell align="left" sx={{ width: '25%' }}>{t('common.'+item.role)}</TableCell>
                                    <TableCell align="left" sx={{ width: '25%' }}>{props.organizations.find(obj => obj.id === item.organizationId)?.name?.trim() ?? ""}</TableCell>
                                    <TableCell align="left" sx={{ width: '25%' }}>{item.description}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            { !addOrEditOpen &&
            <Grid container spacing={0}>
                <Grid size={4}>
                    <ButtonPrimary
                        key={'add_new_tenant_group'}
                        onClick={() => openAddOrEditOpen(true)}>
                        {t("municipality.add_new_tenant_group")}
                    </ButtonPrimary>
                </Grid>
                <Grid size={4}>
                    <ButtonSecondary
                        disabled={!rowSelect}
                        key={'edit_tenant_group'}
                        onClick={() => openAddOrEditOpen(false)}>
                        {t("municipality.edit_tenant_group")}
                    </ButtonSecondary>
                </Grid>
                <Grid size={4}>
                    <ButtonPrimary
                        disabled={!rowSelect}
                        key={'delete_tenant_group'}
                        onClick={() => deleteGroup()}>
                        {t("municipality.delete_tenant_group")}
                    </ButtonPrimary>
                </Grid>
                <Grid>
                    <ButtonPrimary
                        key={'add_new_tenant_group'}
                        onClick={() => {
                            setEntraDeletionModalOpen(true);
                            props.listRemovedEntraUsers(props.selectedMunicipality.id);
                        }}>
                        {t("municipality.remove_deleted_entra_id_users")}
                    </ButtonPrimary>
                </Grid>
            </Grid>
            }
            { addOrEditOpen &&
                <form noValidate autoComplete="off" className={"location-container"}>
                    <Grid container>
                        <Grid size={12}>
                            <Grid container spacing={0}>
                                <Grid size={12}>
                                    <CompPartitionHeader text={t(isCreate ? "municipality.add_new_tenant_group" : "municipality.edit_tenant_group")}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={6}>
                            <Grid container spacing={0}>
                                <Grid size={12}>
                                    <CompTextField
                                        label={`${t('municipality.tenant_group_id')}*`}
                                        value={selectedItem.groupIdentifier}
                                        name="groupIdentifier"
                                        onChange={handleChange}/>
                                </Grid>
                                <Grid size={12}>
                                    <CompDropdown
                                        label={`${t("user.user_role")}*`}
                                        valueColumn={"id"}
                                        labelColumn={"value"}
                                        rows={roles}
                                        hasEmptyOption={false}
                                        onChange={handleChange}
                                        name="role"
                                        selectedValue={selectedItem.role}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <CompTextFieldNew
                                        isLabelShrink={true}
                                        label={t('municipality.tenant_group_description')}
                                        value={selectedItem.description}
                                        name="description"
                                        multiline
                                        rows={6}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={6}>
                            <Grid container spacing={0}>
                                <Grid size={12}>
                                    <CompListTree
                                        onSelect={selectOrganization}
                                        rows={props.organizationTree[10]}
                                        selectedRows={[selectedItem.organizationId]}
                                        name="organizationId"
                                        wholeTreeOpen={true}
                                        keyColumn={'id'}
                                        valueColumn={'name'}>
                                        {t('common.organization')}
                                    </CompListTree>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={12}>
                            <Grid
                                container spacing={1}
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                className={'bottom-button-container'}>
                                <Grid className={'align-right'} size={12}>
                                    <ButtonSpacer>
                                        <ButtonPrimary
                                            key={'add_new_tenant_group'}
                                            onClick={() => submit()}>
                                            {t(isCreate ? "municipality.create" : "municipality.edit")}
                                        </ButtonPrimary>
                                        <ButtonSecondary
                                            key={'closeAddOrEditOpen'}
                                            onClick={() => closeAddOrEditOpen()}>
                                            {t("common.cancel")}
                                        </ButtonSecondary>
                                    </ButtonSpacer>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form> }
            <Modal
                open={entraDeletionModalOpen}
                onClose={() => setEntraDeletionModalOpen(false)}
            >
                <div className={'modal archiveModal'}>
                    <div className={'modalDescription'}>
                        {t("municipality.remove_deleted_confirmation")}
                    </div>
                    <div className={'modalQuestion'+(props.tenantDeletionError ? ' error' : '')} style={{ whiteSpace: 'pre-line' }}>
                        {props.tenantDeletionError && (
                            <div className={`error-label`}>Error: {props.tenantDeletionError}</div>
                        )}
                        {props.tenantUserListInfo && !props.tenantUserListInfo.time && (
                            <div>{t("municipality.start_new_search")}</div>
                        )}
                        {props.tenantUserListInfo && props.tenantUserListInfo.time && (
                            <div>
                                <div>{t("municipality.started")}: {props.tenantUserListInfo.time ? moment.parseZone(props.tenantUserListInfo.time).format("HH:mm:ss") : ''}</div>
                                <div>{t("municipality.state")}: {props.tenantUserListInfo.failed ? t("municipality.failed") : (props.tenantUserListInfo.finished ? t("municipality.ready") : t("municipality.in_progress"))}</div>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {
                                        props.tenantUserListInfo.usersToDelete?.map((user) => (
                                            <li
                                                key={user.id}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '8px 12px',
                                                    borderBottom: '1px solid #ddd',
                                                }}
                                            >
                                                <span>{user.text}</span>
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-${user.objectId}`}
                                                    value={user.objectId}
                                                    checked={selectedObjectIds.includes(user.objectId)}
                                                    onChange={() => handleToggle(user.objectId)}
                                                />
                                            </li>
                                        ))
                                }
                                    {
                                        props.tenantUserListInfo.usersToDelete?.length === 0 && (
                                            <li>
                                                <span>{t("municipality.none_to_remove")}</span>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className={'modalButtons'}>
                        <ButtonSecondary disabled={selectedObjectIds.length === 0} onClick={() => props.deleteRemovedEntraUsers(props.selectedMunicipality.id, { objectIds: selectedObjectIds})}>
                            {t("municipality.remove_chosen")}
                        </ButtonSecondary>
                        <ButtonPrimary onClick={() => props.checkRemovedEntraUsers(props.selectedMunicipality.id)}>
                            {t("municipality.start_new_search")}
                        </ButtonPrimary>
                        <ButtonPrimary onClick={() => props.listRemovedEntraUsers(props.selectedMunicipality.id)}>
                            {t("municipality.update")}
                        </ButtonPrimary>
                        <ButtonSecondary onClick={() => setEntraDeletionModalOpen(false)}>
                            {t("municipality.close")}
                        </ButtonSecondary>
                    </div>
                </div>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        selectedMunicipality: state.municipality.selectedMunicipality,
        organizations: state.municipality.organizations,
        organizationTree: state.municipality.organizationTree,
        tenantInfo: state.municipality.tenantInfo,
        userRoles: state.root.userRoles,
        tenantUserDeletionInfo: state.municipality.tenantUserDeletionInfo,
        tenantUserListInfo: state.municipality.tenantUserListInfo,
        tenantUserCheckInfo: state.municipality.tenantUserCheckInfo,
        tenantDeletionError: state.municipality.tenantDeletionError
    }
}
const mapDispatchToProps = dispatch => {
    return {
        createTenantGroup: (data) => dispatch(createTenantGroup(data)),
        editTenantGroup: (data) => dispatch(editTenantGroup(data)),
        deleteTenantGroup: (id) => dispatch(deleteTenantGroup(id)),
        listOrganizations: (municipalityId) => dispatch(listOrganizations(municipalityId)),
        getKey: (municipalityId, organizationId, onSuccess) => dispatch(getKey(municipalityId, organizationId, onSuccess)),
        createKey: (data, onSuccess) => dispatch(createKey(data, onSuccess)),
        deleteKey: (data, onSuccess) => dispatch(deleteKey(data, onSuccess)),
        deleteRemovedEntraUsers: (municipalityId, objectIdsToDelete) => dispatch(deleteRemovedEntraUsers(municipalityId, objectIdsToDelete)),
        listRemovedEntraUsers: (municipalityId) => dispatch(listRemovedEntraUsers(municipalityId)),
        checkRemovedEntraUsers: (municipalityId) => dispatch(checkRemovedEntraUsers(municipalityId))
    };
}

const EntraIdComponent = connect(mapStateToProps, mapDispatchToProps)(EntraIdWindow);

export {EntraIdComponent};